<template>
    <div class="box-wrapper">
        <div class="pagination d-flex align-center justify-content-end">
            <div class="pagination-item" v-if="skipToFirst">
                <button type="button" @click="onClickFirstPage" :disabled="isInFirstPage"
                    aria-label="Go to previous page" class="side-navigation">
                    <img class="" src="/static/images/icons/skip_to_first_page.svg" alt="chevron-right-icon" />
                </button>
            </div>
            <div class="pagination-item">
                <button type="button" @click="onClickPreviousPage" :disabled="isInFirstPage"
                    aria-label="Go to previous page" class="side-navigation">
                    <img class="" src="/static/images/icons/paginationLeftChevron.svg" alt="chevron-right-icon" />
                </button>
            </div>
            <div class="d-flex align-center justify-content-center">
              <div class="previousNumber"><span>{{ currentPage }}</span></div>
              <div class="of-text d-flex align-center justify-content-center"><span>{{ $t('of') }}</span></div>
              <div class="nextNumber d-flex align-center justify-content-center"><span>{{ totalPages }}</span></div>
            </div>
            <div class="pagination-item">
                <button type="button" @click="onClickNextPage" :disabled="isInLastPage" aria-label="Go to next page"
                    class="side-navigation">
                    <img src="/static/images/icons/paginationRightChevron.svg" alt="chevron-right-icon" />
                </button>
            </div>
            <div class="pagination-item" v-if="skipToLast">
                <button type="button" @click="onClickLastPage" :disabled="isInLastPage" aria-label="Go to next page"
                    class="side-navigation">
                    <img src="/static/images/icons/skip_to_last_page.svg" alt="chevron-right-icon" />
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 6,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    skipToFirst: {
      type: Boolean,
      default: false,
    },
    skipToLast: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentRecords() {
      let records = this.currentPage * this.perPage;
      if (this.perPage > this.total) {
        records = this.total;
      }
      if (this.currentPage * this.perPage > this.total) {
        records = this.total;
      }
      return records;
    },
    startPage() {
      if (this.currentPage === 1 || this.totalPages < this.maxVisibleButtons) {
        return 1;
      }
      if (
        this.currentPage === this.totalPages
                && this.totalPages > this.maxVisibleButtons
      ) {
        return this.totalPages - this.maxVisibleButtons + 1;
      }
      if (this.totalPages - this.currentPage < this.maxVisibleButtons - 2) {
        const range = this.totalPages - this.maxVisibleButtons + 1;
        return range < 1 ? 1 : range;
      }
      return this.currentPage - 1;
    },
    pages() {
      const range = [];
      const maxRange = this.startPage < 2
        ? this.startPage + this.maxVisibleButtons
        : this.startPage + this.maxVisibleButtons - 1;
      const pagesRange = this.totalPages < this.maxVisibleButtons
        ? this.totalPages + 1
        : maxRange;
      for (let i = this.startPage; i < pagesRange; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage,
        });
      }
      if (range.length === 0 && this.totalPages === 1) {
        range.push({
          name: 1,
          isDisabled: this.currentPage === 1,
        });
      }
      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    onClickPreviousPage() {
      this.$emit('pagechanged', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('pagechanged', page);
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.currentPage + 1);
    },
    onClickFirstPage() {
      this.$emit('pagechanged', 1);
    },
    onClickLastPage() {
      this.$emit('pagechanged', this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    },
  },
};
</script>
<style scoped>
.previousNumber{
  border-radius: 3px;
  border: 1px solid #4D4D4D;
  background: #FFF;
  width: 61px;
  height: 36px;
  display: flex;
  justify-content: flex-end;
  margin: 0px 8px 0px 18px;
}
.previousNumber span {
  color: #000;
  text-align: right;
  font-size: 16px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  width: 37px;
  height: 26px;
  padding: 5px 12px 5px 12px;
}
.nextNumber span {
  color: #000;
  text-align: right;
  font-size: 16px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  padding: 5px 12px 5px 12px;
}
.of-text span{
  color: #000;
  text-align: right;
  font-size: 16px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
}
.pagination{
  margin: 10px 0px;
}
.box-wrapper {
    text-align: center;
    font-family: Roboto;
    font-style: normal;
    line-height: 21px;
}

.left-transform {
    transform: rotate(-180deg);
}

.pagination_dots {
    vertical-align: sub;
}

.pagination-item>button {
    background-color: white;
    border: 0px;
    padding: 5px 5px;
    color: #01518a;
    font-size: 18px;
}

.pagination-item>button:focus {
    outline: 0px;
}

.pagination-item>button[disabled] {
    opacity: 0.4;
    cursor: not-allowed;
}

.pagination-item.active>button {
    opacity: 1;
    font-weight: bolder;
    font-size: 18px;
    line-height: 16px;
}

/* .pagination-item>button>img,
.pagination-item>button>img:focus {
    width: 25px;
    height: 30px;
    border: 0px;
} */

.pagination-item>button.side-navigation {
  border-radius: 3px;
  background: rgba(230, 230, 230, 0.50);
  padding: 7px;
}

.pagination-item {
    vertical-align: middle;
    margin: 0 5px;
}

.pagination-item.active {
    border-bottom: 4px solid #4c9e45;
    padding-top: 6px;
}

/* span {
    vertical-align: middle;
    margin-left: 10px;
} */

.dis-inline {
    display: inline;
}

.fs-16 {
    font-size: 16px;
}

.fw-normal {
    font-weight: normal;
}
</style>
